import styled from 'styled-components';

const Themes = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px,  1fr));
  row-gap: 2rem;
`;

export default Themes;
